import React, { useEffect, useState } from "react";
import { fetchCmsContent } from "../services/fetchCmsContent";
import MainPageComponents from "../components/CommonComponents/MainPageComponents";

interface PolicyItem {
  title: string;
  slug: string;
  content: string;
}

const HealthSafetyPolicyPage: React.FC = () => {
  const [health, setHealth] = useState<PolicyItem | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchCmsContent("Health & Safety", "/api/cms/health-safety-policy", setHealth, setLoading);
  }, []);

  return (
    <MainPageComponents
      title={health?.title || "Health And Safety Policy"}
      content={health?.content || ""}
      loading={loading}
      updated_at=""
    />);
};

export default HealthSafetyPolicyPage;
